// extracted by mini-css-extract-plugin
export default {"profileGroup":"profileInfo_profileGroup__gvO12","info":"profileInfo_info__yg4Y2","infoName":"profileInfo_infoName__LAkCX","infoDesc":"profileInfo_infoDesc__Clfrn"};